/* tslint:disable */
/* eslint-disable */
/**
 *
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Theme } from "./Theme";
import { ThemeFromJSON, ThemeFromJSONTyped, ThemeToJSON, ThemeToJSONTyped } from "./Theme";
import type { PatchedProjectArea } from "./PatchedProjectArea";
import {
  PatchedProjectAreaFromJSON,
  PatchedProjectAreaFromJSONTyped,
  PatchedProjectAreaToJSON,
  PatchedProjectAreaToJSONTyped,
} from "./PatchedProjectArea";

/**
 *
 * @export
 * @interface Project
 */
export interface Project {
  /**
   *
   * @type {string}
   * @memberof Project
   */
  readonly url: string;
  /**
   *
   * @type {string}
   * @memberof Project
   */
  slug?: string | null;
  /**
   *
   * @type {string}
   * @memberof Project
   */
  name: string;
  /**
   *
   * @type {Date}
   * @memberof Project
   */
  readonly createdAt: Date;
  /**
   *
   * @type {Date}
   * @memberof Project
   */
  readonly updatedAt: Date;
  /**
   *
   * @type {PatchedProjectArea}
   * @memberof Project
   */
  area?: PatchedProjectArea | null;
  /**
   *
   * @type {string}
   * @memberof Project
   */
  readonly organisationName: string;
  /**
   * Extra key/values like address that can be stored by the UI
   * @type {any}
   * @memberof Project
   */
  extraValues?: any | null;
  /**
   *
   * @type {Array<Theme>}
   * @memberof Project
   */
  readonly themes: Array<Theme>;
}

/**
 * Check if a given object implements the Project interface.
 */
export function instanceOfProject(value: object): value is Project {
  if (!("url" in value) || value["url"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("createdAt" in value) || value["createdAt"] === undefined) return false;
  if (!("updatedAt" in value) || value["updatedAt"] === undefined) return false;
  if (!("organisationName" in value) || value["organisationName"] === undefined) return false;
  if (!("themes" in value) || value["themes"] === undefined) return false;
  return true;
}

export function ProjectFromJSON(json: any): Project {
  return ProjectFromJSONTyped(json, false);
}

export function ProjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): Project {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"],
    slug: json["slug"] == null ? undefined : json["slug"],
    name: json["name"],
    createdAt: new Date(json["created_at"]),
    updatedAt: new Date(json["updated_at"]),
    area: json["area"] == null ? undefined : PatchedProjectAreaFromJSON(json["area"]),
    organisationName: json["organisation_name"],
    extraValues: json["extra_values"] == null ? undefined : json["extra_values"],
    themes: (json["themes"] as Array<any>).map(ThemeFromJSON),
  };
}

export function ProjectToJSON(json: any): Project {
  return ProjectToJSONTyped(json, false);
}

export function ProjectToJSONTyped(
  value?: Omit<
    Project,
    "url" | "created_at" | "updated_at" | "organisation_name" | "themes"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    slug: value["slug"],
    name: value["name"],
    area: PatchedProjectAreaToJSON(value["area"]),
    extra_values: value["extraValues"],
  };
}
